                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <div class="listing-page">
    <div class="content-section-port">
        <h1>
            <em>
                <strong>
                    The Art
                </strong>
                <svg class="nectar-scribble basic-underline" viewBox="-400 -55 730 60" preserveAspectRatio="none">
                    <path style="animation-duration: 1.3s;"
                        d="m -383.25 -6 c 55.25 -22 130.75 -33.5 293.25 -38 c 54.5 -0.5 195 -2.5 401 15"
                        stroke="#ffffff" pathLength="1" stroke-width="8" fill="none"></path>
                </svg>
            </em>
            of Effortless Elegance in Our Architectural Wonders
        </h1>
    </div>
</div>
<div class="portfolio-listing-box">
    <div class="box-service-subtag">

        <div class="service-subtag-block">
            <a class="service-subtags" 
               [ngClass]="{'active': activeCategory === ''}"
               (click)="filterByCategory('')">All</a>
            <a *ngFor="let category of categories" 
               class="service-subtags" 
               [ngClass]="{'active': activeCategory === category}"
               (click)="filterByCategory(category)">
               {{ category }}
            </a>
        </div>
    </div>
    
    <div class="loader" *ngIf="loading">Loading...</div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"
        *ngFor="let arr of filteredArray | slice:startIndex:endIndex;">
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate(arr.websitelink)" target="_blank"
                        title="view website"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="Portfolio Image"
                        style="" src="{{arr.img1}}">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src={{arr.img}} alt="Portfolio Banner Image" height="871" width="1300"
                            sizes="(max-width: 1300px) 100vw, 1300px" style="">
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">

                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;"> {{
                                arr.nameprint}}</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">{{arr.infosub}}
                    </a>
                </span>
            </div>
        </div>
    </div>

    <div class="pagination-style-box" *ngIf="filteredArray.length > 9">
        
        <div class="pagination-style">
            <a (click)="changePage(0)"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
            <a *ngIf="activePage != 0" (click)="changePage(activePage-1)"><i class="fa fa-angle-left"
                    aria-hidden="true"></i></a>
            <a (click)="activePage != page ?changePage(page) : ''" *ngFor="let page of totalPageArray "
                [ngClass]="activePage == page ? 'selected' : ''">{{page+1}}</a>
            <a *ngIf="activePage != totalPageArray.length-1" (click)="changePage(activePage+1)"><i class="fa fa-angle-right"
                    aria-hidden="true"></i></a>
            <a (click)="changePage(totalPageArray.length-1)"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
        </div>
    </div>
</div>